// extracted by mini-css-extract-plugin
module.exports = {"SLinkSvg":"LinkSvg_SLinkSvg__mbKkc"};